export const TOUR_HIGHLIGHT_TARGET_SELECTOR_SWITCH_PLAN =
  'tour-highlight__switch-plan'
